<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card :title="$t('NewQuestion')" class="mb-base">
      <vs-prompt :title="$t('NewQuestion')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')"
        @cancel="clearAnswerModal" @accept="SaveAnswer" @close="clearAnswerModal" :active.sync="activePrompt">
        <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
          <form @submit.prevent style="max-height:75vh">
            <div class="mt-5 vx-row w-full " style="padding-left:20px">
              <div class=" lg:w-3/4" style="padding-left:20px">
                <vs-input :label="$t('AnswerText')" v-model="CourseQuestionBankAnswer.AnswerText" class="mt-5 w-full"
                name="AnswerText" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('AnswerText')">{{ errors.first('AnswerText')
              }}</span>
            </div>
            <div class=" lg:w-1/4" style="padding-left:10px;margin-top:25px">
                <label> {{ $t('IsRight') }}</label>
                <vs-checkbox v-model="CourseQuestionBankAnswer.IsRight"></vs-checkbox>
                <span class="text-danger text-sm" v-show="errors.has('IsRight')">{{ errors.first('IsRight') }}</span>
                <!-- <vs-input
                          :value="True"
                          v-model="CourseQuestionBankAnswer.IsRight"
                          type="checkbox"
                          class="mt-5 w-full flex-1"
                          style="width:200px;hight:20px"/>  -->
              </div>
            </div>

          </form>
        </VuePerfectScrollbar>
      </vs-prompt>

      <vs-prompt :title="$t('NewAttachment')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')"
        @cancel="clearAttachmentModal" @accept="SaveAttachment" @close="clearAttachmentModal"
        :is-valid="validateAttachmentForm" :active.sync="activePromptAttachment">
        <!-- <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl"> -->
        <form @submit.prevent style="max-height:75vh">
          <div class="flex-1 pl-5">
            <p> {{ $t('AttachmentType') }}</p>
            <v-select label="Name" class="w-full" v-model="CourseQuestionBankAttachment.AttachmentTypeID"
              :options="attachmentTypes" :reduce="ID => ID.ID" v-validate="'required'" @input="AttachmentChange" />

            <span class="text-warning text-sm" v-if="CourseQuestionBankAttachment.AttachmentType == undefined">You must
              select type to can upload file.</span>
            <span class="text-danger text-sm" v-show="errors.has('attachment-Type')">{{ errors.first('attachment-Type')
            }}</span>
          </div>

          <div class="w-full pl-5 mt-5">
            <vs-input :label="$t('DescriptionOfAttachment')"
              v-model="CourseQuestionBankAttachment.DescriptionOfAttachment" class=" w-full"
              name="DescriptionOfAttachment" />
          </div>

          <div class="vx-col" v-if="CourseQuestionBankAttachment.AttachmentType != undefined">
            <vs-upload automatic :limit="1"
              :accept="CourseQuestionBankAttachment.AttachmentType == undefined ? 'all' : CourseQuestionBankAttachment.AttachmentType.Extention"
              :action="baseURL + 'API/CourseQuestionBank/UploadFile'" :headers="UploadRequestHeader"
              @on-success="successUpload" />
          </div>
        </form>
        <!-- </VuePerfectScrollbar> -->
      </vs-prompt>

      <div class="vx-col flex-1">
      <div class="vx-col">
        <div class=" flex-1">
            <vx-card class="flex-1" :title="$t('Course')">
              <div class="vx-row flex-1">
                <div class="flex-1" style="padding-left:5px">
                  <p>{{ $t('Course') }}</p>
                  <v-select label="Name" class="w-full" v-model="CourseQuestionBank.Course" :options="courses"
                    :reduce="Course => Course" @input="getCourseModules(CourseQuestionBank.Course.ID)" />
                  <!-- <vs-select class="mt-5 w-full" label="Course" v-model="CourseQuestionBank.Course" @change="getCourseModules(CourseQuestionBank.Course.ID)" >
                                                      <vs-select-item :key="index" :value="item" :text="item.Name" v-for="(item,index) in courses" />
                                            </vs-select> -->
                  <span class="text-danger text-sm" v-show="errors.has('Course')">{{ errors.first('Course') }}</span>
                </div>
                <div class="flex-1" style="padding-left:5px"
                  v-show="(CourseQuestionBank.Course || CourseQuestionBank.CourseModuleID > 0) && CourseQuestionBank.CategoryID != 11">
                  <p>{{ $t('CourseModules') }}</p>
                  <v-select label="Name" class="w-full" v-model="CourseQuestionBank.CourseModuleID"
                    :options="courseModules" :reduce="ID => ID.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('CourseModules')">{{ errors.first('CourseModules')
                  }}</span>
                </div>
              </div>
            </vx-card>
          </div>

        </div>
        <div class="vx-row ">
          <div class=" flex-1 lg:w-1/2" style="padding-top:20px;padding-left:15px;padding-right:15px">
            <vx-card class="flex-1" :title="$t('Question')">
              <div class="vx-col flex-1">
                <div class=" vx-col flex-1" style="padding-left:5px">
                  <p>{{ $t('Category') }}</p>
                  <v-select label="Name" class="w-full" v-model="CourseQuestionBank.CategoryID" :options="categories"
                    :reduce="ID => ID.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('Category')">{{ errors.first('Category') }}</span>
                </div>
                <div class="mt-5 vx-col flex-1" style="padding-left:5px">
                  <p>{{ $t('QuestionType') }}</p>
                  <v-select label="Name" class="w-full" v-model="CourseQuestionBank.QuestionTypeID"
                    :options="questionTypes" :reduce="ID => ID.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('QuestionType')">{{ errors.first('QuestionType')
                  }}</span>
                </div>
                <div class="mt-5 flex-1" style="padding-left:5px">
                  <p>{{ $t('QuestionLevel') }}</p>
                  <v-select label="Name" class="w-full" v-model="CourseQuestionBank.QuestionLevelID"
                    :options="questionLevels" :reduce="ID => ID.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('QuestionLevel')">{{ errors.first('QuestionLevel')
                  }}</span>
                </div>
                <div class="mt-5 vx-col">
                  <label class="vs-input--label">{{ $t('QuestionText') }}</label>
                  <vs-textarea class="w-full " v-model="CourseQuestionBank.QuestionText" v-validate="'required'"
                    name="QuestionText" cols="80" rows="7">
                  </vs-textarea>
                  <span class="text-danger text-sm" v-show="errors.has('QuestionText')">{{ errors.first('QuestionText')
                  }}</span>

                <label class="vs-input--label" v-if="CourseQuestionBank.QuestionTypeID == 1">{{ $t('ModelAnswer') }}</label>
                <vs-textarea class="w-full " v-model="CourseQuestionBank.QuestionModelAnswer"
                  v-if="CourseQuestionBank.QuestionTypeID == 1" name="QuestionModelAnswer" cols="80" rows="7">
                </vs-textarea>
                <span v-if="CourseQuestionBank.QuestionTypeID == 1" class="text-danger text-sm"
                  v-show="errors.has('QuestionModelAnswer')">{{ errors.first('QuestionModelAnswer') }}</span>

              </div>
                <!-- <div class="vx-row">
                      <div class="vx-col">
                           <label class="vs-input--label">Picture</label>
                      <vs-upload automatic :limit="1" action="https://localhost:44381/API/CourseQuestionBank/UploadFile"  @on-success="successUpload" />
                      </div>
                     <div>

                     </div>
                    </div> -->
              </div>
            </vx-card>
          </div>
          <div class="vx-col flex-1 lg:w-1/2" style="padding-top:20px;padding-left:15px;">
            <div>
              <vx-card class="flex-1" :title="$t('Answers')">
                <div class="vx-row">
                  <div v-if="CourseQuestionBank.QuestionTypeID == 3">
                    <vs-checkbox v-model="CourseQuestionBank.ExtraAnswer">
                      {{ $t('AddTextAnswer') }}
                    </vs-checkbox>
                  </div>
                  <vs-checkbox v-model="CourseQuestionBank.HaveAttachmentAnswer">
                    {{ $t('AddAttachmentAnswer') }}
                  </vs-checkbox>
                </div>
                <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePrompt = true"
                  v-if="CourseQuestionBank.QuestionTypeID == 2 || CourseQuestionBank.QuestionTypeID == 3">Add answer
                </vs-button>
                <vs-table ref="table" pagination :max-items="5" :data="getListOfAnswers">
                  <template slot="thead">
                    <vs-th>{{ $t('AnswerText') }} </vs-th>
                    <vs-th>{{ $t('IsRight') }}</vs-th>
                    <vs-th>{{ $t('Action') }}</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          <p class="product-name font-medium truncate">{{ tr.AnswerText }}</p>
                        </vs-td>
                        <vs-td>
                          <p class="product-name font-medium truncate">{{ tr.IsRight }}</p>
                        </vs-td>
                        <vs-td class="whitespace-no-wrap">
                          <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="editAnswer(tr)" />
                          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2" @click="openConfirm(tr)" />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </vx-card>
            </div>
            <div>
              <vx-card class="flex-1 mt-5" :title="$t('Attachment')">
                <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
                  @click="activePromptAttachment = true">{{ $t('AddAttachment') }} </vs-button>
                <vs-table ref="table" pagination :max-items="5" :data="getListOfAttachments">
                  <template slot="thead">
                    <vs-th>{{ $t('Description') }}</vs-th>
                    <vs-th>{{ $t('Download') }} </vs-th>
                    <vs-th>{{ $t('Action') }}</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          <p class="product-name font-medium truncate">{{ tr.DescriptionOfAttachment }}</p>
                        </vs-td>
                        <vs-td>
                          <a :href="baseURL + tr.UrlAttachment" download target="_blank"><feather-icon icon="DownloadIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                        </vs-td>
                        <vs-td class="whitespace-no-wrap">
                          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2" @click="openConfirmAttachment(tr)" />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </vx-card>
            </div>
          </div>


        </div>

      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!isFormValid">{{ $t('Submit') }} </vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="danger" @click="cancle">{{ $t('Cancel') }}</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

import DataViewSidebar from "./DataViewSidebar.vue";
import moduleQuestionBank from "@/store/question/questionBank/moduleQuestionBank.js";
import moduleCourse from "@/store/course/moduleCourse.js";

import moduleQuestionLevel from "@/store/settings/questionLevel/moduleQuestionLevel.js";
import moduleMaterialType from "@/store/settings/materialType/moduleMaterialType.js";

import moduleQuestionType from "@/store/settings/questionType/moduleQuestionType.js";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moduleCategory from "@/store/settings/category/moduleCategory.js";
import { domain, mainSetting } from '@/gloabelConstant.js';
import vSelect from 'vue-select'
export default {
  components: {
    DataViewSidebar,
    VuePerfectScrollbar,
    vSelect
  },
  data() {
    return {
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      baseURL: domain,
      selected: [],
      activePrompt: false,
      activePromptAttachment: false,
      itemsPerPage: 10,
      isMounted: false,
      edit: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,
      CourseQuestionBank: {
        CourseQuestionBankAnswers: [],
        CourseQuestionBankAttachments: []
      },
      listOfAnswers: [],
      listOfAttachments: [],
      CourseQuestionBankAnswer: {},
      CourseQuestionBankAttachment: {},
      dataForDeleted: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },

    };
  },
  computed: {
    validateAttachmentForm() {
      return this.CourseQuestionBankAttachment.AttachmentTypeID != undefined
    },
    isFormValid() {

      return !this.errors.any() && this.CourseQuestionBank.QuestionText &&
        (this.CourseQuestionBank.CourseModuleID || this.CourseQuestionBank.CategoryID == 11) &&
        this.CourseQuestionBank.QuestionLevelID && this.CourseQuestionBank.QuestionTypeID && this.CourseQuestionBank.CategoryID;
    },
    currentPage() {
      debugger
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    courseModules() {
      return this.$store.state.questionBankList.courseModules;
    },
    categories() {
      return this.$store.state.categoryList.categories;
    },
    courses() {

      return this.$store.state.courseList.courses;
    },
    questionTypes() {
      var examid = this.CourseQuestionBank.CategoryID;
      return this.$store.state.questionTypeList.questionTypes.filter(function (element) {
        // if(element.ID!=5&&element.ID!=4 &&(element.ID!=1&&this.CourseQuestionBank.ExamTypeID==7))
        debugger
        if ((element.ID != 5 && element.ID != 4 && element.ID != 1 && examid == 11) || (element.ID != 5 && element.ID != 4 && examid != 11))
          return element;
      });
    },
    attachmentTypes() {
      return this.$store.state.materialTypeList.materialTypes;
    },
    questionLevels() {
      return this.$store.state.questionLevelList.questionLevels;
    },
    getListOfAttachments() {

      // return this.listOfAnswers
      return this.CourseQuestionBank.CourseQuestionBankAttachments;
    },
    getListOfAnswers() {

      return this.CourseQuestionBank.CourseQuestionBankAnswers;
    }
  },

  methods: {
    AttachmentChange() {
      var vm = this;
      this.CourseQuestionBankAttachment.AttachmentType = this.attachmentTypes.find((val) => {
        if (vm.CourseQuestionBankAttachment.AttachmentTypeID == val.ID)
          return val;
      });
    },
    successUpload(event) {

      this.CourseQuestionBankAttachment.UrlAttachment = event.target.responseText;
      this.$vs.notify({
        time: 8000, color: 'success', title: 'Upload Success',
        text: this.$t("SuccessuploadyourAttachment")
      })

    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    getCourseModules(id) {

      this.$store.dispatch("questionBankList/GetCourseModulesByCourseID", id);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlert
      });
    },
    openConfirmAttachment(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlertAttachment
      });
    },
    editAnswer(data) {

      this.edit = true;
      this.CourseQuestionBankAnswer = JSON.parse(JSON.stringify(data));
      this.dataForDeleted = JSON.parse(JSON.stringify(data));
      this.activePrompt = true;

    },
    deleteAnswer(data) {

      if (data.ID > 0) {
        this.$store.dispatch("questionBankList/removeAnswer", data.ID);
      }

      const ItemIndex = this.CourseQuestionBank.CourseQuestionBankAnswers.findIndex((p) => p.AnswerText == data.AnswerText)
      //if(ItemIndex!=-1)
      this.CourseQuestionBank.CourseQuestionBankAnswers.splice(ItemIndex, 1)
    },
    deleteAttachment(data) {

      if (data.ID > 0) {
        this.$store.dispatch("questionBankList/removeAttachment", data.ID);
      }

      const ItemIndex = this.CourseQuestionBank.CourseQuestionBankAttachments.findIndex((p) => p.DescriptionOfAttachment == data.DescriptionOfAttachment)
      //if(ItemIndex!=-1)
      this.CourseQuestionBank.CourseQuestionBankAttachments.splice(ItemIndex, 1)
    },
    SaveAnswer() {

      if (this.CourseQuestionBankAnswer.AnswerText) {
        if (this.edit) {
          this.deleteAnswer(this.dataForDeleted);
          this.edit = false;
        }
        this.listOfAnswers.push(this.CourseQuestionBankAnswer);
        this.CourseQuestionBank.CourseQuestionBankAnswers = this.listOfAnswers;
        //this.deletefacility(this.facility);
        // this.$store.commit("classRoomList/ADD_Facility", this.facility);
        this.clearAnswerModal();
      }
    },
    SaveAttachment() {

      if (this.CourseQuestionBankAttachment.DescriptionOfAttachment) {

        this.listOfAttachments.push(this.CourseQuestionBankAttachment);
        this.CourseQuestionBank.CourseQuestionBankAttachments = this.listOfAttachments;
        //this.deletefacility(this.facility);
        // this.$store.commit("classRoomList/ADD_Facility", this.facility);
        this.clearAttachmentModal();
      }
    },
    clearAttachmentModal() {
      this.CourseQuestionBankAttachment = {}
    },
    clearAnswerModal() {
      this.CourseQuestionBankAnswer = {}
    },
    acceptAlert() {
      this.deleteAnswer(this.rowDataForDelete);
      this.$vs.notify({
        time: 8000,
        color: "danger",
        title: this.$t("Deletedrecord"),
        text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    acceptAlertAttachment() {
      this.deleteAttachment(this.rowDataForDelete);
      this.$vs.notify({
        time: 8000,
        color: "danger",
        title: this.$t("Deletedrecord"),
        text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    initValues() {
      this.CourseQuestionBank = {
        CourseQuestionBankAnswers: [],
        CourseQuestionBankAttachments: []
      }
    },
    save_changes() {

      if (this.CourseQuestionBank.QuestionTypeID != 1 && this.CourseQuestionBank.CourseQuestionBankAnswers.length <= 0) {
        this.$vs.dialog({
          color: "warning",
          title: this.$t("Dialogwarning"),
          text: this.$t("therearenoanswersforthisquestion") + "?",
        });
      }

      if (this.CourseQuestionBank.ID != null && this.CourseQuestionBank.ID >= 0) {
        this.$store.dispatch("questionBankList/updateItem", this.CourseQuestionBank);

        this.cancle();
      } else {
        this.$store.dispatch("questionBankList/addItem", this.CourseQuestionBank);
        // this.$store.state.questionBankList.search={};
        this.$store.state.questionBankList.search.pageNum = 1;
        this.cancle();
      }

    },
    cancle() {
      this.$router.go(-1);
    }
  },

  created() {

    const ID = this.$route.params.ID
    if (ID != undefined) {

      this.$store.dispatch("questionBankList/GetItemByID", ID)
        .then(res => {
          this.CourseQuestionBank = res.data
          this.CourseQuestionBank.CourseModuleID = res.data.CourseModuleID
          this.CourseQuestionBank.Course = res.data.CourseModule.Course
          this.getCourseModules(this.CourseQuestionBank.Course.ID)

        })
        .catch(err => {

          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    }
    if (!moduleQuestionBank.isRegistered) {
      this.$store.registerModule("questionBankList", moduleQuestionBank);
      moduleQuestionBank.isRegistered = true;
    }
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    if (!moduleQuestionLevel.isRegistered) {
      this.$store.registerModule("questionLevelList", moduleQuestionLevel);
      moduleQuestionLevel.isRegistered = true;
    }
    if (!moduleQuestionType.isRegistered) {
      this.$store.registerModule("questionTypeList", moduleQuestionType);
      moduleQuestionType.isRegistered = true;
    }
    if (!moduleCategory.isRegistered) {
      this.$store.registerModule("categoryList", moduleCategory);
      moduleCategory.isRegistered = true;
    }
    if (!moduleMaterialType.isRegistered) {
      this.$store.registerModule("materialTypeList", moduleMaterialType);
      moduleMaterialType.isRegistered = true;
    }

    this.$store.dispatch("materialTypeList/fetchDataListItems");
    this.$store.dispatch("categoryList/fetchDataListItems");


    this.$store.dispatch("questionLevelList/fetchDataListItems");
    this.$store.dispatch("questionTypeList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
